@if (isLoaded && attachments) {
  <rt-requisitions-files-container
    [requisitionId]="requisitionId"
    [attachments]="attachments"
  ></rt-requisitions-files-container>
} @else {
  <rt-spinner></rt-spinner>
}
